import { create } from 'zustand';
import { LocationConfigDTO, LocationConfigJson } from '@/shared/api/model';

interface LocationConfigState {
    configs: LocationConfigDTO[];
    selectedConfig: LocationConfigDTO | null;
    isLoading: boolean;
    error: string | null;
    
    // Form state
    configForm: {
        configName: string;
        entityType: string;
        addressType: string;
        configJson: LocationConfigJson;
        isActive: boolean;
        isMandatory: boolean;
    };
    isEditMode: boolean;

    // Actions
    setConfigs: (configs: LocationConfigDTO[]) => void;
    setSelectedConfig: (config: LocationConfigDTO | null) => void;
    setIsLoading: (isLoading: boolean) => void;
    setError: (error: string | null) => void;
    setConfigForm: (form: Partial<LocationConfigState['configForm']>) => void;
    setIsEditMode: (isEditMode: boolean) => void;
    resetConfigForm: () => void;
}

const defaultConfigJson: LocationConfigJson = {
    requiredLevels: [
        { level: 'ZONE', dirId: 387, mandatory: true },
        { level: 'REGION', dirId: 388, mandatory: true },
        { level: 'DISTRICT', dirId: 389, mandatory: true },
        { level: 'WARD', dirId: 392, mandatory: false },
        { level: 'STREET', dirId: 393, mandatory: false }
    ],
    gpsCoordinates: {
        required: false,
        accuracyThreshold: 50.0
    },
    validation: {
        allowInactiveLocations: false,
        requirePostalCode: false
    }
};

export const useLocationConfigStore = create<LocationConfigState>((set) => ({
    configs: [],
    selectedConfig: null,
    isLoading: false,
    error: null,
    
    configForm: {
        configName: '',
        entityType: '',
        addressType: '',
        configJson: defaultConfigJson,
        isActive: true,
        isMandatory: false
    },
    isEditMode: false,

    setConfigs: (configs) => set({ configs }),
    setSelectedConfig: (selectedConfig) => set({ selectedConfig }),
    setIsLoading: (isLoading) => set({ isLoading }),
    setError: (error) => set({ error }),
    setConfigForm: (form) => set((state) => ({ 
        configForm: { ...state.configForm, ...form } 
    })),
    setIsEditMode: (isEditMode) => set({ isEditMode }),
    resetConfigForm: () => set({
        configForm: {
            configName: '',
            entityType: '',
            addressType: '',
            configJson: defaultConfigJson,
            isActive: true,
            isMandatory: false
        },
        isEditMode: false
    })
}));
